<template>
  <span style="text-align: left; position: relative">
    <template v-if="modo == 'new' || modo == 'edit' || modo == 'flow'">
    </template>
    <template v-if="modo == 'list'">
      <v-btn @click="openDetails()">Visualizar</v-btn>

      <v-dialog v-model="modalDetalhes" max-width="1200px">
        <v-card>
          <v-toolbar card dark color="#68b842">
            <v-toolbar-title class="font-weight-bold" style="color: white">{{
              row.nome
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="modalDetalhes = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex
                  xs12
                  v-for="(equipamento, index) in detalhes"
                  :key="index"
                  class="mb-4"
                >
                  <v-card class="elevation-2">
                    <v-card-title class="primary">
                      <span class="subheading font-weight-bold"
                        >Equipamento #{{ index + 1 }}</span
                      >
                    </v-card-title>

                    <v-divider></v-divider>

                    <v-list dense>
                      <v-layout row wrap>
                        <v-flex
                          xs6
                          sm4
                          v-for="campo in equipamento"
                          :key="campo.id"
                        >
                          <v-list-tile>
                            <v-list-tile-content>
                              <v-list-tile-sub-title
                                class="text-uppercase caption grey--text"
                              >
                                {{ campo.nome }}
                              </v-list-tile-sub-title>
                              <v-list-tile-title class="body-2">
                                {{ formatarValor(campo) }}
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-flex>
                      </v-layout>
                    </v-list>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey darken-1" flat @click="modalDetalhes = false"
              >Fechar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </span>
</template>

<script>
import _baseComponent from "@/framework/lib/componente/_base.vue";

//import VueNumeric from "vue-numeric";

export default {
  extends: _baseComponent,

  //components: { VueNumeric },

  computed: {},
  data() {
    return {
      modalDetalhes: false,
      detalhes: [], // Receberá o array(2) com os arrays de campos
      row: {}, // Linha selecionada
    };
  },

  methods: {
    init() {
      console.log("ROW", this.row);
    },

    async openDetails() {
      try {
        this.detalhes - [];
        let res = await global.express.call(
          "/action/estudos/getDetails",
          "post",
          null,
          { id: this.row.id }
        );

        if (res && res.detalhes) {
          this.detalhes = res.detalhes;
          this.modalDetalhes = true;
        }
      } catch (error) {
        console.error("Erro ao buscar detalhes:", error);
        // Aqui você pode usar o tratamento de erro com try/catch que discutimos
      }
    },
    formatarValor(campo) {
      if (campo.tipo === 0 || campo.tipo === 1) {
        return Number(campo.valor).toLocaleString("pt-BR");
      }
      return campo.valor;
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    "row.view": {
      handler(old, newv) {
        console.log("sssss", old, newv);
        if (old != newv) {
          this.init();
        }
      },
      deep: true,
    },
  },
};
</script>
